import { Signal } from '@sorskoot/wonderland-components';
import { Object3D } from '@wonderlandengine/api';
import { GameFlowStates } from './game-flow-controller.js';
import { ObjectiveType } from './game-manager.js';

export class GlobalEvents {
    private static _instance: GlobalEvents;

    static get instance(): GlobalEvents {
        if (!GlobalEvents._instance) {
            GlobalEvents._instance = new GlobalEvents();
        }
        return GlobalEvents._instance;
    }

    interactableGrabbed = new Signal<
        [handedness: 'left' | 'right', object: Object3D]
    >();

    interactableReleased = new Signal<
        [handedness: 'left' | 'right', object: Object3D]
    >();

    teleportRequested = new Signal<[position: Float32Array]>();
    gameStateChanged = new Signal<[state: GameFlowStates]>();
    objectiveCompleted = new Signal<[objective: ObjectiveType]>();

    private constructor() {}
}
